import { create } from 'zustand';
import { institutionsSlice } from './institutions.slice';
import { TInstitutionsStore } from './types';
import { visitNotesTemplatesSlice } from './visitNotesTemplates.slice';

export const useInstitutionsStore = create<TInstitutionsStore>((...arg) => {
  const institutions = institutionsSlice(...arg);
  const visitNotesTemplates = visitNotesTemplatesSlice(...arg);

  return {
    ...institutions,
    ...visitNotesTemplates,

    clearInstitutionsStore: () => {
      const { clearInstitutions } = institutions;
      const { clearVisitNotesTemplates } = visitNotesTemplates;

      clearInstitutions();
      clearVisitNotesTemplates();
    },
  };
});
